export const ALBUM_TYPES = {
  PLAYLIST: 'PLAYLIST',
  ALBUM: 'ALBUM',
  SINGLE: 'SINGLE',
};

export enum ENTITY_TYPES {
  ALBUM = 'album',
  SINGLE = 'single',
  TRACK = 'track',
}

export const ENTITY_TYPES_MAP = {
  [ALBUM_TYPES.ALBUM]: ENTITY_TYPES.ALBUM,
  [ALBUM_TYPES.SINGLE]: ENTITY_TYPES.SINGLE,
  TRACK: ENTITY_TYPES.TRACK,
};

export const ENTITY_GET_OPTIONS = {
  GET: 'GET',
  DOWNLOAD: 'DOWNLOAD',
  BUY: 'BUY',
  NOTHING: 'NOTHING',
};

export enum ENTITY_GET_REQUIREMENT {
  FREE = 'FREE',
  BUY = 'BUY',
  SUBSCRIBE = 'SUBSCRIBE',
  NAME_YOUR_PRICE = 'NAME_YOUR_PRICE',
  NONE = 'NONE',
}
